export default __webpack_public_path__ + "static/media/34.2f98e54e.jpeg";